import HttpService from './http.service';

export default {
  getAll,
  getById,
  create,
  update,
  delete: remove,
  archive,
  unarchive,
  getSummary,
  getPublicById,
  getChargesSummaryDashboard,
};

async function getAll(params) {
  return HttpService.get('/charges', params);
}

async function getById(id) {
  return HttpService.get(`/charges/${id}`);
}

async function getPublicById(id) {
  return HttpService.get(`/public/charges/${id}`);
}

async function create(charge) {
  return HttpService.post('/charges', charge);
}

async function update(id, charge) {
  return HttpService.put(`/charges/${id}`, charge);
}

async function remove(id) {
  return HttpService.delete(`/charges/${id}`);
}

async function archive(id) {
  return HttpService.put(`/charges/${id}/archive`);
}

async function unarchive(id) {
  return HttpService.put(`/charges/${id}/unarchive`);
}

async function getSummary() {
  return HttpService.get('/charges-summary');
}

async function getChargesSummaryDashboard(params) {
  return HttpService.get('/charges-summary-dashboard', params);
}
